import {
  motion
} from "framer-motion";

const Hero = () => {
  const scrollToSection = () => {
    document.getElementById("section").scrollIntoView({ behavior: "smooth" });
  };
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };
  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="flex flex-col items-center text-center mt-20 md:mt-32"
    >
      {/* HEADLINE */}
      <motion.h1
        variants={item}
        className="text-4xl md:text-6xl font-semibold text-black dark:text-white leading-tight max-w-3xl"
      >
         We helped 100+ healthcare providers and 3000+ healthcare seekers
      </motion.h1>

      {/* PARAGRAPH */}
      <motion.p
        variants={item}
        className="mt-6 text-gray-600 dark:text-gray-400 text-base md:text-lg max-w-2xl"
      >
        We bring a Pre-Consultant AI Assistant to the front desk of healthcare — it engages patients, conducts an initial assessment, and prepares a decision‑ready brief so clinicians can move faster with greater consistency.
      </motion.p>

      {/* BUTTON */}
      <motion.button
        onClick={scrollToSection}
        variants={item}
        whileHover={{
          scale: 1.08,
          boxShadow: "0px 15px 40px rgba(0,0,0,0.15)",
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 200 }}
        className="mt-8 px-6 py-3 rounded-lg bg-white dark:bg-gray-200 text-black font-medium shadow-lg"
      >
        Book a free call
      </motion.button>
    </motion.div>
  );
};

export default Hero;
